import * as types from '../mutation-types'
const state = {
	contacts: []
}

const actions = {
	fetchContacts ({ commit }) {
		return window.axios.get('/contacts').then((response) => {
			commit(types.STORE_CONTACTS, response.data)
			return response.data
		})
	}
}

const mutations = {
	[types.STORE_CONTACTS] (state, contacts) {
		state.contacts = contacts;
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}